"use strict";
exports.__esModule = true;
exports.useDebounce = void 0;
var React = require("react");
exports.useDebounce = function (value, delay) {
    var _a = React.useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    React.useEffect(function () {
        var handler = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        return function () {
            clearTimeout(handler);
        };
    }, [value]);
    return debouncedValue;
};
